<!-- Avatar Video -->
<div class="avatar">
  <qai-call-video
    [displayName]="controlService?.isCaptionsOn
            ? ''
            : 'Coach'"
    [isSpeaking]="showAvatarSpeakingBorder"
    [indicatorStatus]="showAvatarLoadingIndicator ? 'loading' : 'audio'"
  >
    <div class="videosStack" videoSlot>
      <div class="video-canvas-wrapper">
        <video
          id="avatar-video-realtime"
          #avatarVideoRealtime
          [attr.playsinline]="true"
          [attr.webkit-playsinline]="true"
          [ngClass]="realtimeService?.customBackgroundUrl ? 'avatar-video-hidden' : 'avatar-video-visible'"
          class="avatar-video-realtime"
        ></video>
        @if (realtimeService?.customBackgroundUrl) {
          <canvas
            id="chroma-canvas"
            #chromaCanvas
            class="chroma-canvas"
          ></canvas>
        }
      </div>
      <audio
        id="avatar-audio-realtime"
        [attr.playsinline]="true"
        [attr.webkit-playsinline]="true"
      ></audio>
    </div>
    @if (showAvatarSpeakingIndicator) {
      <qai-call-audio-indicator
        size="medium"
        status="audio"
      />
    }
    @if (showAvatarLoadingIndicator) {
      <qai-call-audio-indicator
        size="medium"
        status="loading"
      />
    }
    @if (controlService?.isCaptionsOn) {
      <qai-call-captions
        [displayName]=""
        [maxLines]="4"
      >{{ playerService?.avatarSpeech() }}</qai-call-captions>
    }
  </qai-call-video>
</div>

<!-- User Video -->
@if (shouldShowUserVideo) {
  <div class="user">
    <qai-call-video
      [displayName]="userName.first"
      [fullName]="userName.full"
      [showInitials]="showUserInitials"
      [isMuted]="!callStore?.getIsMicOn() || callStore?.getIsPaused()"
      [isSpeaking]="showUserSpeakingBorder"
    >
      <video
        videoSlot
        id="user-video"
        muted
        [attr.playsinline]="true"
        [attr.webkit-playsinline]="true"
      ></video>
      @if (showUserSpeakingIndicator) {
        <qai-call-audio-indicator
          size="small"
          status="audio"
        />
      }
    </qai-call-video>
  </div>
}
